import { AttributeValue } from "../../../library-js/dom-tools/AttributeValue";
import { ClassFlag } from "../../../library-js/dom-tools/ClassFlag";
import { ElementAttribute } from "../../../library-js/dom-tools/ElementAttribute";
import { ElementType } from "../../../library-js/dom-tools/ElementType";
import { OnClick } from "../../../library-js/dom-tools/EventListeners";

export class ArticleToggle
{ 
  static readonly type  = new ElementType( "article-toggle" );
  static readonly closer  = new ElementType( "article-toggle-close-label" );
  static readonly opener  = new ElementType( "article-toggle-open-label" );

  static applyOnDocument()
  {
    ArticleToggle.type.forAllInDoc( e => this.applyOnElement( e ) );
  }
  
  static applyOnElement( e:Element )
  { 
    let openers = ArticleToggle.opener.queryAll( e );
    let closers = ArticleToggle.closer.queryAll( e );

    openers.forEach(
      ( opener )=>
      {
        OnClick.add( opener as HTMLElement, ()=> ClassFlag.visible.set( e ) );
      }
    )
    
    closers.forEach(
      ( closer )=>
      {
        OnClick.add( closer as HTMLElement, ()=> ClassFlag.visible.removeFrom( e ) );
      }
    )

   
  }

}